import React, { forwardRef } from 'react';

import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';
import { Box } from '@vk-hr-tek/ui/Box';

import useStyles from './ListBox.styles';

export interface ListBoxCategory {
  label: string;
  value: string;
}

/**
 * Компонент ListBox представляет собой контейнер для списка элементов.
 *
 * @param {Object} props - Свойства компонента.
 * @param {React.ReactNode | React.ReactNode[]} [props.children] - Дочерние элементы, которые будут отображаться в списке.
 * @returns {React.ReactNode} Возвращает JSX-элемент.
 */
export const ListBox = forwardRef<
  HTMLDivElement,
  {
    loading: boolean;
    children?: React.ReactNode | React.ReactNode[];
  }
>(({ loading, children, ...rest }, ref) => {
  const { classes } = useStyles();

  if (!children) return null;

  return (
    <div {...rest} ref={ref}>
      {loading && (
        <Box display="flex" justifyContent="center" p="16">
          <CircularProgress size={30} />
        </Box>
      )}
      {!loading && <ul className={classes.listBox}>{children}</ul>}
    </div>
  );
});
